import { EventNames, globalEventBus } from '@littlebird/event-bus';
import { useEffect } from 'react';

import { invalidatePeople } from './people-wiki.query';

/** Refetch the Wiki list and any open person page when a lookup ends. */
export const usePeopleWikiChangedEvents = () => {
  useEffect(() => {
    const subscription = globalEventBus.on(
      EventNames.PEOPLE_WIKI_CHANGED,
      () => {
        invalidatePeople();
      }
    );

    return () => subscription.unsubscribe();
  }, []);
};
